export default "__VITE_ASSET__CPA1VfK$__"